export default __webpack_public_path__ + "static/media/osoDeAnteojos.d8e0f138.png";